import { render } from "./InputOnlyNumber.vue?vue&type=template&id=49a556f0"
import script from "./InputOnlyNumber.vue?vue&type=script&lang=ts"
export * from "./InputOnlyNumber.vue?vue&type=script&lang=ts"
script.render = render

export default script